import React, { memo, useRef, useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
import { Select, Form, Input } from 'antd';

import Label from '@components/formItem/FormLabel';
import { FORM_KEYS } from './config/form.keys';
import { INPUT_MAP } from './config/form.config';
import { VALUEDRIVER_TIPS, VALUEDRIVER_OPTIONS } from '@model';

import {
  INPUT_COMPS,
  INPUT_TYPE,
} from '@components/dragableTableFrom/formItems';
import ValueDriverRadioSetting from '@modules/insights/valueDriverManager/content/radioSetting';

const InputNumber = INPUT_COMPS[INPUT_TYPE.VALUE_DRIVER_NUMBER];

const Item = Form.Item;

const LabelWithCompany = ({
  company,
  companyClassName,
  className,
  editable,
  changeEbit,
  text,
  ...props
}) => {
  const [isEditing, toggleEdit] = useState(false);
  const inputRef = useRef();
  const handleToggleEdit = () => {
    if (!editable) {
      return;
    }

    toggleEdit((state) => !state);
  };

  const stopEdit = () => {
    toggleEdit(false);
  };

  const handleInputBlur = (e) => {
    e.target.value.trim() && changeEbit && changeEbit(e.target.value);
    stopEdit();
  };

  useEffect(() => {
    isEditing &&
      setTimeout(() => {
        inputRef.current.focus();
      });
  }, [isEditing]);

  return (
    <div
      className={editable ? 'editable-label-wrapper' : ''}
      onClick={(e) => e.stopPropagation()}
    >
      {isEditing ? (
        <Input
          maxLength={40}
          defaultValue={text}
          ref={inputRef}
          className="label-input"
          onClick={(e) => e.stopPropagation()}
          onBlur={handleInputBlur}
          size="small"
        />
      ) : (
        <Label
          {...props}
          text={text}
          className={className}
          wrapperClassName={editable ? 'editable-label' : ''}
        />
      )}
      {editable && !isEditing && (
        <span
          className="appkiticon icon-pencil-fill a-font-12"
          onClick={handleToggleEdit}
        />
      )}
      <span className={`companyname-text ${companyClassName || ''}`}>
        {company}
      </span>
    </div>
  );
};

function TopForm({
  magnification,
  toggleMagnification,
  labelSuf,
  data,
  formInstance,
  isSystemSetting,
  visible = true,
  formChange = () => {},
}) {
  const [EBITText, changeEbit] = useState(FORM_KEYS.CLIENT_EBITDA.label);
  const handleToggleMagnification = (newMag) => {
    if (newMag !== magnification) {
      toggleMagnification(newMag);
      formChange();
    }
  };

  const numberInputConfig = {
    config: {
      magnification,
      negative: true,
    },
  };

  const subText = labelSuf ? `(In ${labelSuf})` : '';

  useEffect(() => {
    const currentText = formInstance.getFieldValue([FORM_KEYS.EBIT_LABEL.key]);

    if (currentText === EBITText) {
      return;
    }

    let newEbitData = {};

    if (currentText !== EBITText.trim()) {
      newEbitData = {
        [FORM_KEYS.CLIENT_EBITDA.key]: null,
        [FORM_KEYS.TARGET_EBITDA.key]: null,
      };
    }

    formInstance.setFieldsValue({
      ...formInstance.getFieldsValue(),
      ...newEbitData,
      [FORM_KEYS.EBIT_LABEL.key]: EBITText.trim(),
    });
  }, [EBITText]);

  useEffect(() => {
    data?.ebitLabel && changeEbit(data?.ebitLabel);
  }, [data?.ebitLabel]);

  return (
    <div
      className="top-form-row"
      style={{ display: `${visible ? 'flex' : 'none'}` }}
    >
      <div className="top-form-item">
        <Form.Item
          name={FORM_KEYS.EBIT_LABEL.key}
          initialValue={EBITText}
          hidden
          noStyle
        />
        <Item
          initialValue={magnification}
          name={FORM_KEYS.FORMAT.key}
          label={
            <div>
              <Label
                text={FORM_KEYS.FORMAT.label}
                tip={VALUEDRIVER_TIPS[FORM_KEYS.FORMAT.key]}
                className="is-required"
              />
              <span>&nbsp;</span>
            </div>
          }
          required
        >
          <Select
            onSelect={handleToggleMagnification}
            options={VALUEDRIVER_OPTIONS[FORM_KEYS.FORMAT.key]}
            dropdownClassName="value-driver-dropdown"
          />
        </Item>
      </div>

      {!isSystemSetting && (
        <>
          {' '}
          <div className="top-form-item">
            <InputNumber
              name={
                formInstance.getFieldValue(['ebit']) ||
                FORM_KEYS.CLIENT_EBITDA.key
              }
              label={
                <LabelWithCompany
                  editable
                  subText={subText}
                  text={EBITText}
                  tip={VALUEDRIVER_TIPS[FORM_KEYS.CLIENT_EBITDA.key]}
                  className="is-required"
                  company={data?.buyerCompanyName || 'Buyer'}
                  changeEbit={changeEbit}
                />
              }
              rules={INPUT_MAP[FORM_KEYS.CLIENT_EBITDA.key].rules}
              inputProps={numberInputConfig}
            />
          </div>
          <div className="top-form-item">
            <InputNumber
              name={FORM_KEYS.TARGET_EBITDA.key}
              label={
                <LabelWithCompany
                  text={FORM_KEYS.TARGET_EBITDA.label}
                  companyClassName="target"
                  company={data?.targetCompanyName || 'Target'}
                />
              }
              rules={INPUT_MAP[FORM_KEYS.TARGET_EBITDA.key].rules}
              inputProps={numberInputConfig}
            />
          </div>
          <div className="top-form-item">
            <InputNumber
              name={FORM_KEYS.DEN.key}
              label={
                <Label
                  subText={subText}
                  text={FORM_KEYS.DEN.label}
                  tip={VALUEDRIVER_TIPS[FORM_KEYS.DEN.key]}
                  className="is-required"
                />
              }
              rules={INPUT_MAP[FORM_KEYS.DEN.key].rules}
              inputProps={numberInputConfig}
            />
          </div>
        </>
      )}
      <ValueDriverRadioSetting
        isSystemSetting={isSystemSetting}
        formChange={formChange}
      />
    </div>
  );
}

TopForm.propTypes = {};

export default memo(TopForm);
